<ngx-select
    [noAutoComplete]="false"
    [allowClear]="false"
    [multiple]="false"
    (select)="onChange($event)"
    [items]="supplierRegions"
    [(ngModel)]="selectedRegionID"
></ngx-select>
